export default function About() {
  return (
    <div className="px-6 md:px-12 lg:px-24 pt-20 md:pt-28" data-testid="about-page">
      <div className="max-w-3xl mx-auto">
        <div className="text-[11px] uppercase tracking-[0.32em] text-black/55 mb-6">
          About this journal
        </div>
        <h1 className="font-serif text-5xl md:text-7xl font-light tracking-tighter leading-none">
          Why I write
        </h1>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img
              src="https://images.unsplash.com/photo-1709855256067-12ad9a64ac06?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
              alt="Author"
              className="w-full grayscale"
            />
          </div>
          <div className="md:col-span-7 article-prose">
            <p>
              I started this journal because most of what is written online is
              shouting, and most of what I think requires whispering.
            </p>
            <p>
              The questions I care about — *what is true, what is real, what is
              worth a life* — do not respond well to noise. So I am trying
              something quieter: short essays, written by hand, posted only
              when there is something worth saying.
            </p>
            <p>
              You will find work here under four roofs — Philosophy, Spirituality,
              Science, and Personal Reflection. They are not separate buildings.
              They are rooms in the same house.
            </p>
            <blockquote>
              "The unexamined life is not worth living." — and the unwritten
              examination, I have learned, tends to vanish.
            </blockquote>
            <p>
              Thank you for reading. If something here lands, leave a reflection.
              If nothing does, leave anyway, kindly.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
